import React, { useCallback, useEffect, useState } from "react";
import { SingleValue } from "react-select";
import { Spinner } from "react-bootstrap";
import { downloadExcelFile, getConsultores } from "helpers/Consultores";
import { getRegiones } from "helpers/Regiones";
import {
  IConsultorChoosen,
  IConsultorData,
  IConsultorDataChoosen,
  IConsultorFilter,
  IConsultorSelect,
} from "constants/interfaces/consultor.interface";
import { IRegion } from "constants/interfaces/regiones.interface";
import GridList from "components/GridList";
import Alert from "components/Alert";
import { Input, Option, Select } from "components/Input/Input.styled";
import { IAlertProps } from "components/Alert/Alert.interface";
import { Button } from "components/Button/Button.styled";
import { Anchor, Label, Paragraph, Title } from "components/Text";
import { Layout } from "components/Layout/Layout.styled";
import { descargarResolucionById, getResoluciones } from "helpers/Resoluciones";
import { IResolucion } from "constants/interfaces/resolucion.interface";
import SelectCustom from "components/Select";
interface Option {
  value: string;
  label: string;
}

const Consultores = () => {
  const [alert, setAlert] = useState<IAlertProps>({
    show: false,
    title: "",
    message: "",
    type: "danger",
  });
  const [regiones, setRegiones] = useState<{ label: string; value: string }[]>(
    []
  );
  const [selectedOption, setSelectedOption] = useState<SingleValue<Option>>(null);

  const [resoluciones, setResoluciones] = useState<IResolucion[]>([]);
  const [filter, setFilter] = useState<IConsultorFilter>({
    nombre: "",
    nroRegistro: null,
    vigente: 2,
    region: "",
  });
  const [data, setData] = useState<IConsultorData>({
    isLoading: true,
    isDownloading: false,
    data: [],
    pagination: { total: 0, page: 1, limit: 10, skip: 0 },
  });

  const [dataChoosen, setDataChoosen] = useState<IConsultorDataChoosen>({
    data: [],
    pagination: { total: 0, page: 1, limit: 0, skip: 0 }
  })

  const getDataConsultoresChoosen = useCallback(async () => {
    try {

      const result = await getConsultores(filter, dataChoosen.pagination);
      const dataConsultores = result.data;
      const options: IConsultorSelect[] = [];
      dataConsultores.data.forEach((element: any) => {
        let obj = {
          value: element.NroRegistro,
          label: `${element.Nombre} ${(element.ApPaterno != null ? element.ApPaterno : '')} ${(element.ApMaterno != null ? element.ApMaterno : '')}`
        }
        options.push(obj);
      });
      setDataChoosen({ ...dataChoosen, data: options })

    } catch (error: any) {

    }

  }, [])

  const getDataConsultores = useCallback(async () => {
    setData((prevData) => ({ ...prevData, isLoading: true }));

    try {
      const result = await getConsultores(filter, data.pagination);

      // Asegúrate de que 'pagination' esté disponible antes de hacer el set
      const { pagination = { total: 0, page: 1, limit: 10, skip: 0 } } = result.data || {};

      setTimeout(() => {
        setData({
          data: result.data.data || [],
          pagination,
          isLoading: false,
        });
      }, 1000);
    } catch (error: any) {
      const title =
        error.response?.status === 404
          ? "No se encontraron resultados."
          : "Error al cargar los datos.";
      const message =
        error.response?.status === 404
          ? "No se encontraron resultados para los filtros seleccionados."
          : "Ups! Hubo un error al cargar los datos, por favor, intenta nuevamente o prueba en otro momento.";

      setAlert((a) => ({
        ...a,
        show: true,
        title,
        message,
        type: "danger",
        icon: "cl-close",
      }));

      setData({
        data: [],
        pagination: { total: 0, page: 1, limit: 10, skip: 0 },
        isLoading: false,
      });

      console.error(error);
    } finally {
      setTimeout(() => {
        setAlert((a) => ({
          ...a,
          show: false,
          message: "",
          title: "",
          icon: "",
          type: null,
        }));
      }, 5000);
    }
  }, [filter, setData, data.pagination]);


  // const getDataConsultores = useCallback(async () => {
  //   setData((prevData) => ({ ...prevData, isLoading: true }));
  //   try {
  //     const result = await getConsultores(filter, data.pagination);
  //     setTimeout(() => {
  //       setData({
  //         data: result.data.data,
  //         pagination: result.data.pagination,
  //         isLoading: false,
  //       });
  //     }, 1000);
  //   } catch (error: any) {
  //     const title =
  //       error.response?.status === 404
  //         ? "No se encontraron resultados."
  //         : "Error al cargar los datos.";
  //     const message =
  //       error.response?.status === 404
  //         ? "No se encontraron resultados para los filtros seleccionados."
  //         : "Ups! Hubo un error al cargar los datos, por favor, intenta nuevamente o prueba en otro momento.";
  //     setAlert((a) => ({
  //       ...a,
  //       show: true,
  //       title,
  //       message,
  //       type: "danger",
  //       icon: "cl-close",
  //     }));
  //     setData({
  //       data: [],
  //       pagination: { total: 0, page: 1, limit: 10, skip: 0 },
  //       isLoading: false,
  //     });
  //     console.error(error);
  //   } finally {
  //     setTimeout(() => {
  //       setAlert((a) => ({
  //         ...a,
  //         show: false,
  //         message: "",
  //         title: "",
  //         icon: "",
  //         type: null,
  //       }));
  //     }, 5000);
  //   }
  // }, [filter, setData, data.pagination]);

  const getDataRegionesSclt = useCallback(async () => {
    try {
      const data = await getRegiones();
      if (Array.isArray(data)) {
        setRegiones(
          data.map((region: IRegion) => ({
            label: region.NOMBRE,
            value: region.CODREGION.toString(),
          }))
        );
      } else {
        setRegiones([]);
      }
    } catch (error) {
      setAlert((a) => ({
        ...a,
        show: true,
        type: "danger",
        title: "Error al cargar regiones",
        message: "Por favor, intenta nuevamente.",
        icon: "cl-close",
      }));
      console.error(error);
    } finally {
      setTimeout(() => {
        setAlert((a) => ({
          ...a,
          show: false,
          message: "",
          title: "",
          icon: "",
          type: null,
        }));
      }, 5000);
    }
  }, [setRegiones]);

  const handleDownloadExcelFile = useCallback(async () => {
    try {
      setAlert((a) => ({
        ...a,
        show: true,
        type: "info",
        title: "Descargando archivo...",
        icon: "cl-download",
        message: "Tu descarga comenzará en breve.",
      }));
      setData({
        ...data,
        isDownloading: true,
      });
      const response = await downloadExcelFile(filter);
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "consultores.xlsx");
      document.body.appendChild(link);
      link.click();
      setData({
        ...data,
        isDownloading: false,
      });
    } catch (error) {
      console.error(error);
      setAlert((a) => ({
        ...a,
        show: true,
        type: "danger",
        icon: "cl-close",
        title: "Error al descargar archivo",
        message: "Por favor, intenta nuevamente.",
      }));
    } finally {
      setTimeout(() => {
        setAlert((a) => ({
          ...a,
          show: false,
          message: "",
          title: "",
          icon: "",
          type: null,
        }));
        setData({
          ...data,
          isDownloading: false,
        });
      }, 5000);
    }
  }, [filter, data]);

  const handleDownloadResolucion = async (tipo: string) => {
    try {
      setAlert((a) => {
        return {
          ...a,
          show: true,
          type: "info",
          title: "Descargando resolución...",
          icon: "cl-download",
          message: "Tu descarga comenzará en breve.",
        };
      });
      const response = await getResoluciones(tipo);
      const { IdResolucion, NombreResolucion } = response[0];
      let resolucionResponse = null;
      if (IdResolucion)
        resolucionResponse = await descargarResolucionById(IdResolucion);
      if (resolucionResponse) {
        const url = window.URL.createObjectURL(new Blob([resolucionResponse]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `${NombreResolucion}.pdf`);
        document.body.appendChild(link);
        link.click();
      } else {
        setAlert((a) => ({
          ...a,
          show: true,
          type: "danger",
          icon: "cl-close",
          title: "Error al descargar resolución",
          message: "Por favor, intenta nuevamente",
        }));
      }
    } catch (error) {
      console.error(error);
      setAlert((a) => ({
        ...a,
        show: true,
        type: "danger",
        icon: "cl-close",
        title: "Error al descargar resolución",
        message: "Por favor, intenta nuevamente",
      }));
    } finally {
      setTimeout(() => {
        setAlert((a) => ({
          ...a,
          show: false,
          message: "",
          title: "",
          icon: "",
          type: null,
        }));
      }, 5000);
    }
  };

  const handleGetResoluciones = async () => {
    try {
      const resoluciones = await getResoluciones();
      setResoluciones(resoluciones);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    getDataRegionesSclt();
    handleGetResoluciones();
  }, [getDataConsultores, handleDownloadExcelFile]);

  useEffect(() => {
    if (filter.nroRegistro == null) getDataConsultores();
  }, [filter.nroRegistro]);

  useEffect(() => {
    getDataConsultores();
  }, [
    data.pagination.page,
    data.pagination.limit,
    filter.region,
    filter.vigente,
  ]);

  useEffect(() => {
    getDataConsultoresChoosen();
  }, [])



  return (
    <Layout className="py-5">
      <div className="container">
        <Alert
          type={alert.type}
          show={alert.show}
          title={alert.title}
          icon={alert.icon}
          message={alert.message}
          onClose={() => setAlert({ ...alert, show: false, message: "" })}
        />
        <Title className="h1">Consultores</Title>
        <Paragraph>
          Visualiza los últimos registros actualizados sobre los diferentes
          consultores vigentes.{" "}
        </Paragraph>
        <hr className="mb-2" />
        {resoluciones.map((resolucion) => (
          <>
            <Paragraph key={resolucion.IdResolucion} bold="true">
              {resolucion.Alias}.{" "}
              <Anchor
                onClick={() =>
                  handleDownloadResolucion(resolucion.TipoResolucion.toString())
                }
              >
                Ver
              </Anchor>
              .
            </Paragraph>
            <br />
          </>
        ))}
        <hr className="mb-2" />
        {/* <Paragraph bold="true">
          Revisa aquí los consultores inscritos al 30/06/2024.{" "}
          <Anchor onClick={() => handleDownloadResolucion('1')}>Ver</Anchor>.
        </Paragraph>
        <br/>
        <Paragraph bold="true">
          Revisa aquí las calificaciones de los consultores evaluados el 2023.{" "}
          <Anchor onClick={() => handleDownloadResolucion('2')}>Ver</Anchor>.
        </Paragraph> */}
        <form className="form-row">
          <div className="col-md-12 col-lg-12 col-xl-12 col-sm-12 col-xs-12 col-ss-12">
            <div className="form-group">
              <Label htmlFor="inputNombreConsultor">Nombre del consultor/a:</Label>
              <SelectCustom
                options={dataChoosen.data}
                onChange={(selectedOption) => {
                  setSelectedOption(selectedOption)
                  if (selectedOption) {
                    setFilter({
                      ...filter,
                      nroRegistro: Number.parseInt(selectedOption.value),
                    });
                  }
                  else{
                    setFilter({
                      ...filter,
                      nroRegistro: null
                    });
                  }
                }}
                placeHolder="Seleccione un consultor/a"
                isClereable={true}
                value={selectedOption}
              />
              {/* <Label htmlFor="inputNombreConsultor">Nombre:</Label>
              <Input
                id="inputNombreConsultor"
                className="form-control w-100"
                type="text"
                placeholder="Nombre del consultor/a"
                value={filter.nombre}
                onChange={(e) =>
                  setFilter({ ...filter, nombre: e.target.value })
                }
              />{" "} */}
            </div>
          </div>
          <div className="col-md-3 col-lg-3 col-xl-3 col-sm-12 col-xs-12 col-ss-12">
            <div className="form-group">
              <Label htmlFor="inputNroRegistro">Nro. Registro:</Label>
              <Input
                id="inputNroRegistro"
                className="form-control"
                type="number"
                placeholder="Nro. Registro"
                value={filter.nroRegistro ?? ""}
                onChange={(e) =>
                  setFilter({
                    ...filter,
                    nroRegistro: Number.parseInt(e.target.value),
                  })
                }
              />{" "}
            </div>
          </div>
          <div className="col-md-3 col-lg-3 col-xl-3 col-sm-12 col-xs-12 col-ss-12">
            <div className="form-group">
              <Label htmlFor="slctRegion">Vigente:</Label>
              <Select
                id="slctVigente"
                className="form-control"
                value={filter.vigente}
                onChange={(e) => {
                  if (e.target.value === "2")
                    setFilter({ ...filter, vigente: 2 });
                  else {
                    setFilter({
                      ...filter,
                      vigente: Number.parseInt(e.target.value),
                    });
                  }
                }}
              >
                <Option value="2">Seleccione...</Option>
                <Option value="1">Vigente</Option>
                <Option value="0">No Vigente</Option>
              </Select>
            </div>
          </div>
          <div className="col-md-3 col-lg-3 col-xl-3 col-sm-12 col-xs-12 col-ss-12">
            <div className="form-group">
              <Label id="labelSlctRegion" htmlFor="slctRegion">
                Region:
              </Label>
              <Select
                id="slctRegion"
                className="form-control"
                aria-labelledby="labelSlctRegion"
                value={filter.region}
                onChange={(e) => {
                  const selectedRegion = e.target.value;
                  if (selectedRegion === "0") {
                    setFilter({ ...filter, region: "" });
                  } else {
                    setFilter({ ...filter, region: selectedRegion });
                  }
                }}
              >
                <Option value="0">Seleccione...</Option>
                {regiones.map((region) => (
                  <Option key={region.value} value={region.value}>
                    {region.label}
                  </Option>
                ))}
              </Select>
            </div>
          </div>
          <div className="col-md-3 col-lg-3 col-xl-3 col-sm-12 col-xs-12 col-ss-12">
            <div className="my-3">
              <Button
                className="btn btn-color-estandar w-100"
                type="button"
                onClick={() => {
                  getDataConsultores();
                }}
              >
                <i className="cl cl-search mr-2"></i>
                <span className="texto">Buscar</span>
              </Button>
            </div>
          </div>
        </form>
        <div className="d-flex justify-content-end">
          <Button
            className="btn btn-primary mr-auto"
            onClick={() => {
              handleDownloadExcelFile();
            }}
          >
            {data.isDownloading ? (
              <div className="d-flex align-items-center justify-content-center text-center">
                <Spinner className="mr-2" />
                Descargando...
              </div>
            ) : (
              <>
                <i className="cl cl-download mr-2"></i> Descargar Excel
              </>
            )}
          </Button>
          <Button
            className="btn btn-primary"
            onClick={() => {
              setSelectedOption(null)
              setFilter({
                nroRegistro: null,
                vigente: 2,
                region: "0",
                nombre: "",
              });
              getDataConsultores();
            }}
          >
            <i className="cl cl-close mr-2"></i>
            <span className="texto">Limpiar filtros</span>
          </Button>
        </div>
        <hr />
        <GridList
          data={data}
          isLoading={data.isLoading}
          setData={setData}
          onItemClick={(v) => {
            window.location.href = `/consultores/${v.PersonaID}`;
          }}
        />
      </div>
    </Layout>
  );
};

export default Consultores;
